<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('woocommerce products')"
      :columns="columns"
      :page_length="50"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/woocommerce/product/datatables"
      ><template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="synch_from_server"
        >
          <span class="icon">
            <i class="fa fa-server"></i>
          </span>
          <span>{{ $t("synch from server") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template></generic-table
    >
    <product-modal ref="product_modal" @order_updated="refresh" />
    <edit-product-modal ref="edit_product_modal" @order_updated="refresh" />
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_currency,
  format_date_time,
} from "@/utils";
import ProductModal from "./product_modal/Index.vue";
import EditProductModal from "./edit_product_modal/Index.vue";

export default {
  name: "WoocommerceOrdersDatatable",
  components: { GenericTable, ProductModal, EditProductModal },
  props: {},
  data() {
    let v = this;
    return {
      extra_buttons: [],
      columns: [
        {
          title: v.$t("name"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name;
          },
        },
        {
          title: v.$t("sku"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.sku;
          },
        },
        {
          title: v.$t("type"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.$t(row.type);
          },
        },
        {
          title: v.$t("price"),
          searchable: false,
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row.json_data, null, 2)}</pre>`;
            return row.price || "";
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row.json_data, null, 2)}</pre>`;
            return v.$t(row.status) || "";
          },
        },
        {
          title: v.$t("stock"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row.json_data, null, 2)}</pre>`;
            let r = v.$t(row.stock_status);
            if (row.stock_quantity) r += ` (${row.stock_quantity})`;
            return r || "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "10%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return format_currency(row.balance) || "";
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.product_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.edit_product_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("update"),
                icon: "fa fa-recycle",
                icon_class: "is-small",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to update product from server?"),
                    v,
                    () => {
                      v.$root.loader(true);
                      get("/woocommerce/product/from-server", {
                        uuid: uuid,
                      })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        })
                        .finally(() => {
                          v.$root.loader(false);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete product?"),
                    v,
                    () => {
                      v.$root.loader(true);
                      del("/woocommerce/product", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        })
                        .finally(() => {
                          v.$root.loader(false);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    synch_from_server() {
      let v = this;
      v.$root.loader(true);
      get("/woocommerce/product/synch")
        .then(() => {
          v.refresh();
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    create() {
      let v = this;
      v.$refs.edit_product_modal.create_modal();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
